export const EVENT_NAME = '12 HORAS COM FORTEENS';
export const EVENT_DATE = '31/07';
export const EVENT_HOURS = '20h às 8h';
export const EVENT_PRICE = 3000;

export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format((Number.isFinite(cents) ? cents : 0) / 100);
}

export function normalizePhone(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (!digits) return '';
  return digits.startsWith('55') && digits.length > 11 ? digits : `55${digits}`;
}

export function formatPhoneInput(input: string): string {
  const digits = input.replace(/\D/g, '');
  return digits.startsWith('55') ? digits.slice(0, 13) : digits.slice(0, 11);
}

export function displayPhone(input?: string | null): string {
  const digits = (input ?? '').replace(/\D/g, '').replace(/^55/, '');
  if (digits.length === 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  if (digits.length === 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return input ?? '—';
}

export function maskPhone(input?: string | null): string {
  const pretty = displayPhone(input);
  if (pretty === '—') return pretty;
  return pretty.replace(/\d(?=\d{4})/g, '•');
}

export function validBrazilPhone(input: string): boolean {
  const digits = input.replace(/\D/g, '').replace(/^55/, '');
  return /^(?:[1-9]\d)(?:9\d{8}|\d{8})$/.test(digits);
}

export function validFullName(value: string): boolean {
  const parts = value.trim().split(/\s+/).filter(Boolean);
  return parts.length >= 2 && parts.every((part) => part.length >= 2);
}

export function validEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '—';
  // SQLite CURRENT_TIMESTAMP is UTC but omits the timezone suffix. Without
  // normalizing it, browsers may interpret the value as local time.
  const normalized = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/u.test(value) ? `${value.replace(' ', 'T')}Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'America/Sao_Paulo',
  }).format(date);
}

export function humanPaymentStatus(status: string): string {
  const labels: Record<string, string> = {
    pending_payment: 'Pagamento não realizado',
    paid: 'Pagamento aprovado',
    manual_free: 'Confirmada',
    failed: 'Pagamento não concluído',
    refunded: 'Pagamento estornado',
  };
  return labels[status] ?? status;
}

export function toWhatsAppUrl(message: string, phone?: string): string {
  const target = phone ? normalizePhone(phone) : '';
  return `https://wa.me/${target}?text=${encodeURIComponent(message)}`;
}

export function queryString(values: Record<string, string | number | boolean | undefined | null>): string {
  const parameters = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') parameters.set(key, String(value));
  });
  const result = parameters.toString();
  return result ? `?${result}` : '';
}
